import { get, post, remove } from "./api";

export interface EmailSnippetView {
  id: string;
  name: string;
  subject: string;
  description: string; // HTML body
  visibility: "Private" | "Shared";
  tags: string[];
  projectId?: string;
  createdAt: string;
  updatedAt: string;
}

export interface EmailSnippetForm {
  id?: string;
  name: string;
  subject: string;
  description: string; // HTML body
  visibility: "Private" | "Shared";
  tags: string[];
  projectId?: string;
}

export const getEmailSnippets = async (): Promise<EmailSnippetView[]> => {
  const { data = [] } = await get({ path: `/email-snippets` });
  return data;
};

export const saveEmailSnippet = async (
  workspaceId: string,
  form: EmailSnippetForm
): Promise<EmailSnippetView> => {
  const { data } = await post({
    path: `/workspaces/${workspaceId}/email-snippets`,
    data: form,
  });
  return data;
};

export const deleteEmailSnippet = async (workspaceId: string, snippetId: string): Promise<void> => {
  await remove({
    path: `/workspaces/${workspaceId}/email-snippets/${snippetId}`,
  });
};
